import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "./model.css";

export const Loadbalance = ({
  showModal,
  closePopUp,
  otp,
  setOtp,
  amount,
  setAmount,
  updateBalance,
  sendotpHandler
}) => {
  return (
    <Modal show={showModal}>
      <div class="modal-content  alerttext">
        <div class="modal-header">
          <h5 id="">Load Balance</h5>
           <Button
            onClick={() => sendotpHandler()}
            size="sm"
          >
           Resend otp
          </Button> 
          </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 col-sm-12 mb-4">
              <div class="form-group row">
                <label
                  for="otp"
                  class="col-sm-2 col-form-label col-form-label-sm"
                >
                  OTP
                </label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    id="otp"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e)=>setOtp(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 mb-4">
              <div class="form-group row">
                <label
                  for="amount"
                  class="col-sm-2 col-form-label col-form-label-sm"
                >
                  Amount
                </label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    id="amount"
                    placeholder="Enter Amount"
                    value={amount}
                    onChange={(e)=>setAmount(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="modal-footer">
       <p className="text-success" >otp has been send to admin number</p>
       
          <Button variant="secondary" onClick={closePopUp} size="sm">
            Cancel
          </Button>
          {/* <Button
            // disabled={checkDisable()}
            onClick={() => updateBalance()}
            // variant={checkDisable() ? "secondary" : "primary"}
            size="sm"
          >
           Resend otp
          </Button> */}
          <Button
            // disabled={checkDisable()}
            onClick={() => updateBalance()}
            // variant={checkDisable() ? "secondary" : "primary"}
            size="sm"
          >
            Load Balance
          </Button>
          
        </div>
      </div>
    </Modal>
  );
};
